import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import accountLogin from "./loginComponent/accountLogin";
import phoneLogin from "./loginComponent/phoneLogin";
import LoginFooter from "../Footer";
export default {
  data: function data() {
    return {
      logo: require("../../assets/img/logo.png"),
      city: require("../../assets/img/city.png"),
      model: 'first',
      apkQrcodeImg: '',
      codePanel: false,
      nodeEnv: ''
    };
  },
  activated: function activated() {},
  created: function created() {
    this.tokenLogin();
  },
  methods: {
    getApkQrcodeImg: function getApkQrcodeImg(apkType) {
      this.apkQrcodeImg = this.$config.baseURL + "version/latest/qrcode-img/" + apkType + "?t=" + new Date();
      this.codePanel = true;
    },
    handleClick: function handleClick(tab) {
      this.model = tab.name;
    },
    //过滤一级菜单下子菜单问空的
    filterEmptyArr: function filterEmptyArr(arr) {
      var arr1 = [];
      for (var key in arr) {
        if (arr[key].children.length || arr[key].permissionId == 261) {
          arr1.push(arr[key]);
        }
      }
      return arr1;
    },
    tokenLogin: function tokenLogin() {
      if (process.env.NODE_ENV === 'production') {
        if (process.env.type === 'testing') {
          this.nodeEnv = 'testing';
        } else {
          this.nodeEnv = 'production';
        }
      } else {
        this.nodeEnv = 'testing';
      }
      var token = JSON.parse(localStorage.getItem('token'));
      var self = this;
      if (token) {
        self.fullscreenLoading = true;
        Lib.M.ajax({
          'method': "get",
          'url': 'user/verify',
          'params': {},
          'data': {},
          'headers': {
            token: token.tokenId.replace(/"/g, "")
          },
          'success': function success(data) {
            sessionStorage.setItem("data", JSON.stringify(data.obj.user));
            sessionStorage.setItem("token", JSON.stringify(data.obj.token));
            localStorage.setItem("token", JSON.stringify(data.obj.token));
            sessionStorage.setItem("menu", JSON.stringify(data.obj.menu));
            sessionStorage.setItem("menuEng", JSON.stringify(self.filterEmptyArr(data.obj.menuEng)));
            sessionStorage.setItem("permission", JSON.stringify(data.obj.permission));
            self.$store.dispatch("dispatchIsLogin", 1);
            if (data.obj.user.roles[0].roleId === 'role-20250808112144-91jz607e') {
              self.$router.push("/main/bidMarketList");
            } else {
              if (data.obj.user.dept.branchUnitId) {
                if (data.obj.user.dept.branchUnitId === 'dept-20230209092043-mq40sqtk' || data.obj.user.dept.branchUnitId === 'dept-20190923113717-1j4004gd') {
                  self.$router.push("/main/international/dataScreening");
                } else {
                  self.$router.push("/main/dataScreening");
                }
              } else {
                self.$router.push("/main/dataScreening");
              }
            }
          },
          "error": function error(data) {
            if (data.code) {
              self.$message({
                message: data.userInfo,
                type: "warning"
              });
            } else {
              self.$message({
                message: "登录失效，请重新登录",
                type: "warning"
              });
            }
          }
        });
      }
    }
  },
  components: {
    accountLogin: accountLogin,
    phoneLogin: phoneLogin,
    LoginFooter: LoginFooter
  }
};